/** Day-of-week chips for a post-it schedule. */
import type {
  DayOfWeekOptions as DayOfWeekOptionsType,
  DayOfWeek,
  PostItColor,
} from '@/types/post-it.types';
import { cn } from '@/lib/utils';
import {
  TEXT_COLOR_MAP,
  BORDER_COLOR_MAP,
  POST_IT_WEEKDAY_OPTIONS,
} from '@/components/post-its/post-it-configs';
import { getScheduleChipClasses, toggleDayOfWeek } from '@/components/post-its/post-it-form-utils';

/** Props for {@link DayOfWeekOptions}. */
interface DayOfWeekOptionsProps {
  value: DayOfWeekOptionsType;
  onChange: (value: DayOfWeekOptionsType) => void;
  color?: PostItColor;
}

/** Day-of-week chips for a post-it schedule. */
export function DayOfWeekOptions({
  value,
  onChange,
  color = 'jaune',
}: Readonly<DayOfWeekOptionsProps>) {
  const textColor = TEXT_COLOR_MAP[color] || TEXT_COLOR_MAP.jaune;
  const borderColor = BORDER_COLOR_MAP[color] || BORDER_COLOR_MAP.jaune;

  const handleDayToggle = (day: DayOfWeek) => {
    onChange({ ...value, daysOfWeek: toggleDayOfWeek(value.daysOfWeek, day) });
  };

  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <p className={cn('text-xs font-medium', textColor)}>Jours de la semaine</p>
        <div className="flex flex-wrap gap-1">
          {POST_IT_WEEKDAY_OPTIONS.map((d) => (
            <button
              key={d.value}
              type="button"
              onClick={() => handleDayToggle(d.value)}
              className={cn(
                'w-10 py-1 rounded text-xs border transition-all',
                borderColor,
                getScheduleChipClasses(color, value.daysOfWeek?.includes(d.value) || false),
              )}
            >
              {d.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
